import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';

export function CartPage() {
    return (
        <div className="section animate-fade-in">
            <div className="container mx-auto">
                <h1 className="text-display-sm font-display font-bold text-neutral-900 mb-8">
                    Shopping Cart
                </h1>
                <div className="text-center py-16">
                    <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-neutral-100 mb-6">
                        <ShoppingBag className="h-10 w-10 text-neutral-400" />
                    </div>
                    <h2 className="text-xl font-semibold text-neutral-900 mb-2">
                        Your cart is empty
                    </h2>
                    <p className="text-neutral-500 mb-8">
                        Looks like you haven't added anything yet.
                    </p>
                    <Link to="/products" className="btn-primary">
                        Start Shopping
                    </Link>
                </div>
            </div>
        </div>
    );
}
